
// Selected from data using Rainbow CSV extension for VSCode with:
// SELECT parseFloat(a2).toFixed(3), parseFloat(a3).toFixed(3), Math.round(parseFloat(a5))

import { RawGasPowerPlantData } from "./interface"


export const gas_plants_data: RawGasPowerPlantData[] = [
[51.539,-2.670,1145],
[51.684,-4.993,2199],
[53.233,-3.084,1380],
[52.727,0.380,386],
[53.315,-2.723,800],
[52.204,-0.267,740],
[54.845,-5.783,1246],
[54.727,-5.765,656],
[52.757,0.192,819],
[51.763,0.009,715],
[53.595,-0.752,893],
[53.437,-2.410,884],
[52.479,-1.913,2],
[52.510,-1.809,100],
[52.510,-0.681,350],
[57.478,-1.788,2177],
[50.396,-4.900,140],
[52.806,-0.133,860],
[53.364,-0.797,1332],
[51.525,-0.096,2],
[50.388,-4.012,885],
[51.494,0.425,4],
[52.585,1.733,420],
[50.898,-1.438,898],
[53.601,-0.146,1365],
[53.654,-0.255,900],
[53.542,-0.504,240],
[53.638,-0.236,1180],
[51.172,-2.015,2],
[53.073,-0.860,1772],
[53.276,-2.110,23],
[51.663,-0.022,442],
[51.468,-2.108,10],
[53.734,-0.243,1200],
[53.131,-1.215,4],
[51.546,-0.258,132],
[52.989,-1.090,3],
[50.830,-0.231,420],
[57.173,-2.118,1],
[53.267,-2.531,130],
[53.306,-0.786,445],
[56.459,-2.980,4],
[54.508,-6.091,15],
[53.199,-1.210,10],
[51.486,-0.140,3],
[51.697,-3.417,16],
[51.491,0.195,4],
[51.504,0.234,1],
[51.504,0.233,2],
[51.540,0.509,12],
[51.284,0.299,5],
[51.292,0.360,1],
[50.824,-0.677,1],
[51.226,-0.489,2],
[50.963,-1.281,2],
[51.018,-1.692,1],
[51.273,-2.169,1],
[51.129,0.890,21],
[52.577,-0.203,245],
[52.986,-3.057,20],
[52.506,-2.193,20],
[52.892,-1.475,13],
[51.425,0.601,792],
[54.619,-3.519,8],
[51.842,-2.263,20],
[51.430,-1.004,45],
[51.674,-3.159,20],
[54.965,-1.596,4],
[52.072,-1.330,12],
[53.428,-2.418,20],
[53.677,-1.655,50],
[50.992,-1.535,1],
[51.566,-2.967,20],
[51.566,-2.968,16],
[51.512,0.507,732],
[51.806,-3.225,21],
[51.649,-4.016,38],
[52.529,-1.392,16],
[53.276,-1.202,4],
[52.976,-1.324,7],
[52.906,-1.401,40],
[53.315,-1.138,7],
[53.123,-1.321,5],
[53.077,-2.177,20],
[53.062,-1.413,5],
[53.062,-1.414,14],
[52.957,-1.071,15],
[52.956,-1.069,5],
[52.005,-0.738,20],
[52.904,-1.241,7],
[53.310,-1.117,4],
[52.582,-2.108,16],
[52.290,-1.911,20],
[53.133,-1.219,20],
[51.800,-3.232,16],
[52.976,-1.323,7],
[51.787,-3.223,16],
[51.787,-3.223,16],
[51.699,-4.131,10],
[50.974,-2.910,10],
[52.107,-1.912,1],
[51.629,-3.455,18],
[52.924,-1.189,15],
[52.884,-1.464,58],
[53.099,-2.181,7],
[52.039,-0.762,6],
[50.573,-3.611,5],
[51.507,-3.700,10],
[51.526,-2.565,50],
[56.011,-3.696,145],
[51.624,-1.264,100],
[51.626,-1.270,1550],
[52.935,-1.179,40],
[50.950,-1.474,20],
[51.865,-2.264,40],
[53.091,-1.270,6],
[51.547,-2.976,832],
[53.718,-2.537,60],
[50.850,-1.382,53],
[50.938,-1.350,20],
[51.593,-3.797,20],
[53.849,-3.031,20],
[54.703,-1.291,50],
[53.187,-2.425,20],
[54.607,-1.244,50],
[54.608,-1.244,50],
[53.798,-0.418,50],
[51.596,-1.140,12],
[51.136,-2.998,6],
[53.782,-2.643,90],
[50.623,-2.489,45],
[53.595,-0.750,720],
[53.776,-2.364,20],
[53.526,-2.315,20],
[53.707,-2.468,20],
[53.403,-3.047,20],
[52.576,-0.203,50],
[53.541,-0.508,50],
[51.798,-3.245,21],
[51.937,-0.513,50],
[52.544,-2.020,21],
[51.698,-3.416,10],
[51.376,-0.116,50],
[55.917,-4.710,20],
[53.529,-2.165,20],
[52.492,-2.020,10],
[50.834,-1.377,135],
[53.543,-2.142,20],
[55.902,-4.484,20],
[53.482,-2.957,4],
[53.426,-2.117,5],
[53.340,-2.715,5],
[52.149,-0.419,4],
[51.368,1.391,20],
]
